<template>
  <scout-form
    :is-modified="!!isReviewSaved"
    :half="half"
    label="行動ターゲティング"
  >
    <div class="boss-layout boss-layout-start">
      <label
        class="boss-checkbox"
        data-test="is-review-saved"
      >
        <input
          :checked="isReviewSaved"
          class="boss-input-checkbox"
          type="checkbox"
          @change="$emit('update:isReviewSaved', $event.target.checked)"
        >この求人を気になるリストに保存している会員
      </label>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'

export default {
  components: {
    ScoutForm
  },
  props: {
    isReviewSaved: {
      required: true,
      type: Boolean
    },
    half: {
      default: false,
      type: Boolean
    }
  }
}
</script>
